var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoArticleFound = function SvgNoArticleFound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 60.5,
    fill: "#00B2B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0373 100.85L108 20.5001",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3809 50.8667V26.5619C58.3809 24.4667 60.0571 23 62.1523 23H90.2285C92.3237 23 93.9999 24.6762 93.9999 26.5619V85.2286C93.9999 87.3238 92.3237 88.7905 90.2285 88.7905H81.0094",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7422 97.381H32.6089C30.5136 97.381 28.6279 95.7048 28.6279 93.4V61.5524C28.6279 59.4571 30.3041 57.5714 32.6089 57.5714H70.7422C72.8375 57.5714 74.7232 59.2476 74.7232 61.5524V93.4C74.7232 95.7048 73.047 97.381 70.7422 97.381Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 68.0476H74.0952",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9614 57.5714V67",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9229 57.5714V67",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6758 57.5714V67",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6372 57.5714V67",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3901 57.5714V67",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.857 38.7143C71.1713 38.7143 73.0475 36.8381 73.0475 34.5238C73.0475 32.2095 71.1713 30.3333 68.857 30.3333C66.5426 30.3333 64.6665 32.2095 64.6665 34.5238C64.6665 36.8381 66.5426 38.7143 68.857 38.7143Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.524 38.7143C85.8383 38.7143 87.7144 36.8381 87.7144 34.5238C87.7144 32.2095 85.8383 30.3333 83.524 30.3333C81.2096 30.3333 79.3335 32.2095 79.3335 34.5238C79.3335 36.8381 81.2096 38.7143 83.524 38.7143Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.857 53.381C71.1713 53.381 73.0475 51.5048 73.0475 49.1905C73.0475 46.8761 71.1713 45 68.857 45C66.5426 45 64.6665 46.8761 64.6665 49.1905C64.6665 51.5048 66.5426 53.381 68.857 53.381Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.524 53.381C85.8383 53.381 87.7144 51.5048 87.7144 49.1905C87.7144 46.8761 85.8383 45 83.524 45C81.2096 45 79.3335 46.8761 79.3335 49.1905C79.3335 51.5048 81.2096 53.381 83.524 53.381Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.524 68.0476C85.8383 68.0476 87.7144 66.1715 87.7144 63.8571C87.7144 61.5428 85.8383 59.6667 83.524 59.6667C81.2096 59.6667 79.3335 61.5428 79.3335 63.8571C79.3335 66.1715 81.2096 68.0476 83.524 68.0476Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.524 82.7143C85.8383 82.7143 87.7144 80.8381 87.7144 78.5238C87.7144 76.2095 85.8383 74.3333 83.524 74.3333C81.2096 74.3333 79.3335 76.2095 79.3335 78.5238C79.3335 80.8381 81.2096 82.7143 83.524 82.7143Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7613 76.4286H28.6279V91.0952H66.7613V76.4286Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoArticleFound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-article-found.d9fb787e.svg";
export { ForwardRef as ReactComponent };